import { render } from "./Manage.vue?vue&type=template&id=12212e26&scoped=true&lang=pug"
import script from "./Manage.vue?vue&type=script&lang=js"
export * from "./Manage.vue?vue&type=script&lang=js"

import "./Manage.vue?vue&type=style&index=0&id=12212e26&lang=scss&scoped=true"
import "./Manage.vue?vue&type=style&index=1&id=12212e26&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12212e26"]])

export default __exports__